module.exports = {
      id: "vikatanplay-usage",
      viewBox: "0 0 22.5 23.3",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#vikatanplay",
      toString: function () {
        return this.url;
      }
    }